import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import quote from './modules/quotes/quoteStore';
import auth from './modules/auth/authStore';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: 'dragonball-vuex',
  storage: window.localStorage,
  modules: ['auth', 'quote']
});

export default new Vuex.Store({
  modules: {
    auth,
    quote
  },
  plugins: [vuexLocal.plugin]
});
